
import TranResourcesApi from './src/Tranresources'
import RegionApi from './src/Region'
import RegionList from './src/RegionList'
import MonitorApi from './src/Monitor'


let apis = {
   TranResourcesApi,
   RegionApi,
   RegionList,
   MonitorApi
};

export default apis;
